import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import auth from './modules/auth.js'
import session from './modules/session.js'
import testing from './modules/testing.js'
import profile from './modules/profile.js'
import questions from './modules/questions.js'
import results from './modules/results.js'

// Ключи переменных из state которые сохраняются в localStorage
const persistedState = [
    'auth',
    'session.route',
    'questions.current'
]

Vue.use(Vuex)

export function createStore () {
    const debug = process.env.NODE_ENV !== 'production'
    const plugins = [
        createPersistedState({
            paths: persistedState,
            key: 'app.v1.5',
        })
    ]
    const modules = {
        auth,
        session,
        profile,
        questions,
        testing,
        results
    }


    const store = new Vuex.Store({
        strict: debug,
        state: {
            dev: false
        },
        actions: {
            reset ({dispatch}) {
                dispatch('session/reset', null, {root: true})
                dispatch('testing/reset', null, {root: true})
                dispatch('questions/reset', null, {root: true})
            }
        },
        plugins,
        modules
    })

    return store
}
